import React from "react";
import "./imageInput.css";
import { getStaticText } from '../../lables/lablesService';


const ImageInput = ({ label, fileImage, fileName, handleFile, withWrapper = true }) => {

  const handleImage = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    if ( typeof(handleFile) === 'function' )
      handleFile(file.name, file);
  };

  if ( withWrapper ) {
    return (
      <div className="form-group">
        <label>{label}</label>
        <div className="previewContainer">
          <img
            src={
              typeof fileImage !== "string" && fileImage
                ? URL.createObjectURL(fileImage)
                : fileImage
            }
            alt=""
            className="previewImage"
          />
          <label className="labelForFileInput">
            <span className="selectFileButtons">{getStaticText('file_input_button_label')}</span>
            <span className="selectFileName">{fileName}</span>
            <input
              type="file"
              accept="image/x-png,image/gif,image/jpeg"
              name="icon"
              onChange={handleImage}
              className="form-control d-none"
            />
          </label>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <label>{label}</label>
        <div className="previewContainer">
          <img
            src={
              typeof fileImage !== "string" && fileImage
                ? URL.createObjectURL(fileImage)
                : fileImage
            }
            alt=""
            className="previewImage"
          />
          <label className="labelForFileInput">
            <span className="selectFileButtons">{getStaticText('file_input_button_label')}</span>
            <span className="selectFileName">{fileName}</span>
            <input
              type="file"
              accept="image/x-png,image/gif,image/jpeg"
              name="icon"
              onChange={handleImage}
              className="form-control d-none"
            />
          </label>
        </div>
      </>
    );
  }
  
};

export default ImageInput;
